// Only report errors whose throwing frame lives in our built bundle. Code the
// browser injects into the page — Chrome iOS's internal scripts, auto-translate
// — gets its stack frames attributed to the *document* URL (e.g.
// "/name-generator/elf:224"), producing unfixable noise like the recurring
// "Maximum call stack size exceeded" issues DNDPLAYBOOK-Z0/Z2/TY. All of our
// executable JS is served from /build/assets/; the only inline scripts are the
// try/caught theme bootstrap and the Clarity loader. Events with no derivable
// frame URL (e.g. frameless rejections) are still reported — the SDK only
// applies `allowUrls` when a frame filename exists.
export const sentryAllowUrls = [/\/build\/assets\//];
